import "./changePasswordscreen.css";
import React, { useState, useEffect } from "react"
import { useNavigate } from "react-router-dom";
import OutlinedInput from '@mui/material/OutlinedInput';

import jwt from 'jwt-decode';
import InputAdornment from '@mui/material/InputAdornment';
import IconButton from '@mui/material/IconButton';
import Visibility from '@mui/icons-material/Visibility';
import VisibilityOff from '@mui/icons-material/VisibilityOff';
import PasswordChecklist from "react-password-checklist";
import { CHANGE_PASSWORD } from '../URLs';
import { getLocalStorageItem } from '../localStorageUtils';
import { Button, Container, Card, CardContent, FormGroup, FormControlLabel, Checkbox, Stack, Box, Typography, Grid, FormControl, InputLabel, Select, MenuItem, TextField } from '@mui/material';
import BackButton from '../../common/backButton';
import { PROD } from '../../common/constants';
import { toast } from 'react-toastify';
import { ConfirmationPopover } from '../../common/commonPopovers/confirmationPopover';
import apiClient from "../../axios";

function ChangePasswordScreen() {

  const navigate = useNavigate();

  const [pass, setPass] = useState("")
  const [oid, setOid] = useState("")
  const [password, setPassword] = useState("")
  const [passwordAgain, setPasswordAgain] = useState("")
  const [showPassword, setShowPassword] = React.useState(false);
  const [IsValid, setIsValid] = useState("")
  const handleClickShowPassword = () => setShowPassword((show) => !show);
  const [logModalOpen, setLogModalOpen] = useState(false);
  const handleLogModalOpen = () => setLogModalOpen(true);
  const handleLogModalClose = () => setLogModalOpen(false);
  const [isApiCalled, setIsApiCalled] = useState(false);

  useEffect(() => {
    if (getLocalStorageItem('id_token')) {
      const decoded = jwt(getLocalStorageItem('id_token'));
      setOid(decoded.oid)
    }
  }, [getLocalStorageItem('id_token')]);

  const handleMouseDownPassword = (event) => {
    event.preventDefault();
  };

  
// const onConfirmSubmit = () => {
//   handleLogModalClose();
//   changePassword();
// }


 
    const onConfirmSubmit = async () => {
        if (isApiCalled) return;
        setIsApiCalled(true);
        try {
            await changePassword();
            await new Promise((resolve) => setTimeout(resolve, 1000));
        } catch (error) {
            console.error("API failed:", error);
        } finally {
            setLogModalOpen(false);
            setIsApiCalled(false);
        }
    };

  const onChangePassword = () => {
    handleLogModalOpen();
  }

  function changePassword() {
    apiClient
      .post(CHANGE_PASSWORD,
        {
          "oid": oid,
          "password": password,
        },
        {
          headers: {
            Authorization: 'Bearer ' + getLocalStorageItem('id_token'),
          }
        }
      )
      .then((response) => {
        setPass(response.data);
        toast.success(response.data.message);
                navigate('/')
      })
      .catch(function (error) {
        console.log(error);
      });
  }

  return (
    <>
      <Container maxWidth="xxl">
        {!PROD && <p style={{ textAlign: "right", fontSize: "2vh" }}>REG10</p>}
        <Stack direction="row" alignItems="center" spacing={1} mb={1}>
          <BackButton navigate={navigate} navigateTo="/" />
          <Typography variant="h5" gutterBottom>
          Change Password
          </Typography>
        </Stack>
        <Card>
          <CardContent >
          <Grid container spacing={2} direction="column" style={{ display: "flex", alignItems: "center"}}>
          <FormControl sx={{ m: 1, width: '35ch' }} variant="outlined">
                  <InputLabel htmlFor="outlined-adornment-password">New Password</InputLabel>
                  <OutlinedInput
                    id="outlined-adornment-password"
                    type={showPassword ? 'text' : 'password'}
                    onChange={e => setPassword(e.target.value)}
                    endAdornment={
                      <InputAdornment position="end">
                        <IconButton
                          aria-label="toggle password visibility"
                          onClick={handleClickShowPassword}
                          onMouseDown={handleMouseDownPassword}
                          edge="end"
                        >
                          {showPassword ? <VisibilityOff /> : <Visibility />}
                        </IconButton>
                      </InputAdornment>
                    }
                    label="New Password"
                  />
                </FormControl>
                <FormControl sx={{ m: 1, width: '35ch' }} variant="outlined">
                  <InputLabel htmlFor="outlined-adornment-password">Confirm Password</InputLabel>
                  <OutlinedInput
                    id="outlined-adornment-password"
                    type={showPassword ? 'text' : 'password'}
                    onChange={e => setPasswordAgain(e.target.value)}
                    endAdornment={
                      <InputAdornment position="end">
                        <IconButton
                          aria-label="toggle password visibility"
                          onClick={handleClickShowPassword}
                          onMouseDown={handleMouseDownPassword}
                          edge="end"
                        >
                          {showPassword ? <VisibilityOff /> : <Visibility />}
                        </IconButton>
                      </InputAdornment>
                    }
                    label="Confirm Password"
                  />
                </FormControl>
                <PasswordChecklist
                  rules={["minLength", "specialChar", "number", "capital", "match"]}
                  minLength={8}
                  value={password}
                  valueAgain={passwordAgain}
                  onChange={(isValid) => setIsValid(isValid)}
                />
                <Box display='flex' alignItems="center" justifyContent="center" mt={3}>
                <Button variant="contained" onClick={(e) => onChangePassword(e)} disabled = {!IsValid}>CHANGE PASSWORD</Button>
                </Box>
             </Grid>   
          </CardContent>
        </Card>
      </Container>
      <ConfirmationPopover onOpen={logModalOpen} onConfirm={onConfirmSubmit} onClose={handleLogModalClose} action="Change Password" />
    </>
  )
}

export default ChangePasswordScreen;
